import React from 'react';
import { Buffer } from "buffer";
import { Environment } from "../data/Environment";
import { closeCircle, checkmarkCircle } from 'ionicons/icons';
import Geo, { GeoType } from './Geo';
import Util from '../services/Util';
import { setAuthPersisted } from '../services/pinUtils';

var instance: ServerService = null;

interface IModuleCfg<TValue> {
    [id: string]: TValue;
}

export class ServerService extends React.Component {

    state = {
        host: "",
        port: 0,
        username: "",
        password: "",
        customerKey: "",
        ticket: "",
        base64ticket: "",
        handed: "right",
        params: {},
        pin: "",
        logout: "",
        landingUrl: "/page/home/mytasks"
    }

    // accModule:{[x:number]:any} = {
    //     1:1
    // }

    tabPageIdx = "0"
    nextTab = ""

    moduleCfg: IModuleCfg<number[]> = {
        "0": [1, 2, 0, 0, 0],
        "1": [0, 0, 0, 0, 0]
    }

    moduleEnable = [
        true,  // 0 = Not Select Module
        true,
        false,
        true,
        false,
        false,
        false,
        false
    ]

    task = {
        id: "",
        name: "",
        desc: "",
        type: "",
        doc_ref: "",
        action: "",
        v: ""
    }

    defaultAccount = {
        name: "New Account",
        host: "",
        port: 443,
        username: "",
        password: "",
        customerKey: "",
        // host:"192.168.1.23",
        // port:8443,
        // username:"admin",
        // password:"password",
        // customerKey:'localhost',
    }

    activeAcc = 0

    accounts = [
        {
            name: this.defaultAccount.name,
            host: this.defaultAccount.host,
            port: this.defaultAccount.port,
            username: this.defaultAccount.username,
            password: this.defaultAccount.password,
            customerKey: this.defaultAccount.customerKey,
        }
    ]

    color: any = {
        "positive": "primary",
        "calm": "secondary",
        "royal": "tertiary",
        "balanced": "success",
        "energized": "warning",
        "assertive": "danger",
        "dark": "dark",
        "stable": "medium",
        "light": "light",

        "button-positive": "primary",
        "button-calm": "secondary",
        "button-royal": "tertiary",
        "button-balanced": "success",
        "button-energized": "warning",
        "button-assertive": "danger",
        "button-dark": "dark",
        "button-stable": "medium",
        "button-light": "light"
    }

    icon: any = {
        "ion-close-circled": closeCircle,
        "ion-checkmark-circled": checkmarkCircle,

        "close-circled": closeCircle,
        "checkmark-circled": checkmarkCircle
    }

    lastUrl: any;

    history: any;

    util = new Util();

    constructor(config: any = {}) {
        super(config);

        if (!instance) {
            instance = this;
            var item = window.localStorage.getItem("state")
            if (item) {
                this.state = JSON.parse(item);
            }
            item = window.localStorage.getItem("activeAcc")
            if (item) {
                this.activeAcc = parseInt(item);
            }
            item = window.localStorage.getItem("accounts")
            if (item) {
                this.accounts = JSON.parse(item);
            }
            // item = window.localStorage.getItem("accModule")
            // if (item) {
            //     this.accModule = JSON.parse(item);
            // }
            item = window.localStorage.getItem("moduleCfg")
            if (item) {
                const p: any = JSON.parse(item);
                this.moduleCfg = (p["0"]) ? p : this.moduleCfg;
            }
            /*
            item = window.localStorage.getItem("moduleCfg_" + this.activeAcc)
            if (item) {
                const p: any = JSON.parse(item);
                this.moduleCfg = (p["0"]) ? p : this.moduleCfg;
            }
            */
            item = window.localStorage.getItem("moduleEnable")
            if (item) {
                this.moduleEnable = JSON.parse(item);
            }
            item = window.localStorage.getItem("tabPageIdx")
            if (item) {
                this.tabPageIdx = item;
            }
            item = window.localStorage.getItem("nextTab")
            if (item) {
                this.nextTab = item;
            }
        }

        return instance;
    }

    log = (m: any) => {
        console.log(m);
    }

    clearTicket = () => {
        this.state.ticket = ""
        this.state.base64ticket = ""
    }

    saveLocal = () => {
        window.localStorage.setItem("state", JSON.stringify(this.state));
        window.localStorage.setItem("activeAcc", this.activeAcc.toString());
        window.localStorage.setItem("accounts", JSON.stringify(this.accounts));
    }

    saveModuleLocal = () => {
        //window.localStorage.setItem("accModule", JSON.stringify(this.accModule));
        window.localStorage.setItem("moduleCfg_" + this.activeAcc, JSON.stringify(this.moduleCfg));

        window.localStorage.setItem("moduleCfg", JSON.stringify(this.moduleCfg));
        window.localStorage.setItem("moduleEnable", JSON.stringify(this.moduleEnable));
    }

    saveTabPageIdx = () => {
        window.localStorage.setItem("tabPageIdx", this.tabPageIdx);
        window.localStorage.setItem("nextTab", this.nextTab);
    }

    clearLocal = () => {
        window.localStorage.clear();
    }

    setHistory = (his: any) => {
        this.history = his;
    }

    geo = new Geo();
    getLocation = async (e: any): Promise<GeoType> => {
        return await this.geo.getLocation();
    }

    fetchWithTimeout = (url: string, options: any, timeout = 7000) => {
        return Promise.race([
            fetch(url, options),
            new Promise((_, reject) =>
                setTimeout(() => reject(new Error('timeout')), timeout)
            )
        ]);
    }

    testLogin = (state: any, callback: Function, msgCallback: Function) => {
        const data = { username: state.username, password: state.password }
        fetch("https://" + state.host + ":" + state.port + Environment.API_PREFIX + "login",
            {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'omit',
                referrerPolicy: 'no-referrer',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            }
        )
            .then(res => res.json()
                .then(
                    (result) => {
                        if (result.data) {
                            callback(true);
                        } else {
                            let msg = result.message;
                            if (msg.indexOf("Login failed") >= 0) {
                                msg = "Login failed";
                            }
                            else
                            if (msg.indexOf("Username not specified") >= 0) {
                                msg = "Username not specified";
                            }
                            msgCallback(msg);
                            callback(false);
                        }
                    },
                    (error) => {
                        console.log(error);
                        msgCallback("Login failed : " + error);
                        callback(false);
                    }
                ).catch(e => {
                    msgCallback("Login failed : " + e);
                    callback(false);
                }))
            .catch(e => {
                msgCallback("Login failed : " + e);
                callback(false);
            })
    }

    login = (callback: Function) => {

        console.log("server.login()");
        if (this.accounts.length === 0 || this.accounts[0].name === "") {
            this.accounts[0].name = this.defaultAccount.name;
            this.accounts[0].host = this.defaultAccount.host;
            this.accounts[0].port = this.defaultAccount.port;
            this.accounts[0].username = this.defaultAccount.username;
            this.accounts[0].password = this.defaultAccount.password;
            this.accounts[0].customerKey = this.defaultAccount.customerKey;
        }

        const account = this.accounts[this.activeAcc];

        const state = {
            host: account.host,
            port: account.port,
            username: account.username,
            password: account.password,
            customerKey: account.customerKey,
            ticket: "",
            base64ticket: "",
            handed: "right",
            params: {},
            pin: "",
            logout: "",
            landingUrl: "/page/home/mytasks"
        }

        this.state = state;

        const data = { username: state.username, password: state.password }
        this.fetchWithTimeout("https://" + state.host + ":" + state.port + Environment.API_PREFIX + "login", {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'omit',
            referrerPolicy: 'no-referrer',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        }
            , 20000
        )
            .then((res: any) => {
                res.json().then((result: any) => {
                    if (result.data) {
                        //                    console.log(result.data.ticket);
                        this.state.ticket = result.data.ticket;
                        this.state.base64ticket = Buffer.from(this.state.ticket).toString('base64');

                        window.localStorage.setItem("state", JSON.stringify(this.state));

                        fetch(this.getPrefixUrl() + "mb/cfg", this.getRequest())
                            .then((res: any) => {
                                res.json().then((result: any) => {
                                    console.log("Pin:" + result.data.pin);
                                    this.state.pin = result.data.pin;
                                    this.state.logout = result.data.logout;
                                    window.localStorage.setItem("state", JSON.stringify(this.state));
                                })
                                    .catch((error: any) => {
                                        console.log("mb/cfg not found 1");
                                        //                            window.localStorage.setItem("state", JSON.stringify(this.state));
                                    });
                            })
                            .catch((error: any) => {
                                console.log("mb/cfg not found 2");
                                //                        window.localStorage.setItem("state", JSON.stringify(this.state));
                            });

                        try {
                            this.getLocation(null).then((l: GeoType) => {

                                const loc = l.lat + "," + l.lon;

                                const params: any = { loc: loc, dtl: window.navigator.platform + "," + window.navigator.userAgent }

                                fetch(this.getPrefixUrl() + "mb/location", this.postRequest(params, {}))
                                    .then(res => res.json())
                                    .then(
                                        (result) => {
                                            //console.log("Update Location");
                                        }
                                    );
                            })
                                .catch((e: any) => {
                                    console.log("getLocation Error");
                                    console.log(e);
                                });
                        } catch (e) {
                            console.log("Err Location");
                            console.error(e);
                        }

                        window.localStorage.setItem("state", JSON.stringify(this.state));

                        fetch(this.getPrefixUrl() + "mb/availableModule", this.getRequest())
                            .then((res: any) => {
                                if (res.status == 200) {
                                    res.json().then((result: any) => {
                                        const am: string[] = result.data.am?.split(",")
                                        //                            console.log("am:"+result.data.am)
                                        const mcStr = result.data.mc;
                                        var mc: string[] = [];
                                        if (mcStr) {
                                            mc = mcStr.split(",")
                                        }

                                        for (var i = 0; i < this.moduleEnable.length; i++) {
                                            this.moduleEnable[i] = (i === 0) ? true : false
                                        }

                                        for (var a in am) {
                                            if (am[a].toLowerCase() === "x") {
                                                for (var i = 2; i < this.moduleEnable.length; i++) {
                                                    if (i !== 3) {
                                                        this.moduleEnable[i] = false
                                                    }
                                                }
                                            } else {
                                                //                                    console.log("am[a]:"+am[a])
                                                const i = parseInt(am[a])
                                                this.moduleEnable[i] = true
                                                //this.accModule[i] = 1
                                            }
                                        }

                                        // for(var a in this.moduleEnable) {
                                        //     console.log("moduleEnable["+a+"]:"+this.moduleEnable[a])
                                        // }
                                        /*
                                        const item = window.localStorage.getItem("moduleCfg_" + this.activeAcc)
                                        if (item) {
                                            const p: any = JSON.parse(item);
                                            this.moduleCfg = (p["0"]) ? p : this.moduleCfg;
                                        }
                                        */

                                        for (var i = 1; i < this.moduleEnable.length; i++) {
                                            if (i !== 3) {
                                                if (!this.moduleEnable[i]) {
                                                    for (var j = 0; j < 5; j++) {
                                                        if (this.moduleCfg["0"][j] === i) {
                                                            this.moduleCfg["0"][j] = 0
                                                        }
                                                        if (this.moduleCfg["1"][j] === i) {
                                                            this.moduleCfg["1"][j] = 0
                                                        }
                                                    }
                                                }
                                            }
                                        }

                                        var showSomeModule = false;
                                        for (var i = 0; i < 5; i++) {
                                            if (this.moduleCfg["0"][i] != 0) {
                                                if (this.moduleEnable[this.moduleCfg["0"][i]]) {
                                                    showSomeModule = true;
                                                    break;
                                                }
                                            }
                                            if (this.moduleCfg["1"][i] != 0) {
                                                if (this.moduleEnable[this.moduleCfg["1"][i]]) {
                                                    showSomeModule = true;
                                                    break;
                                                }
                                            }
                                        }

                                        if (!showSomeModule) {
                                            var modIdx = 0;
                                            for (var i = 1; i < this.moduleEnable.length; i++) {
                                                if (i != 3) {
                                                    console.log("enable["+i+"]:"+this.moduleEnable[i]);
                                                    if (this.moduleEnable[i]) {
                                                        if (modIdx < 4) {
                                                            this.moduleCfg["0"][modIdx] = i;
                                                        }
                                                        else
                                                        if (modIdx == 4) {
                                                            if (this.moduleEnable.length > 5) {
                                                                this.moduleCfg["0"][modIdx] = 3;
                                                                modIdx++;
                                                                this.moduleCfg["1"][modIdx-5] = i;
                                                            } else {
                                                                this.moduleCfg["0"][modIdx] = i;
                                                            }
                                                        }
                                                        else {
                                                            this.moduleCfg["1"][modIdx-5] = i;
                                                        }
                                                        modIdx++;
                                                    }
                                                }
                                            }
                                        }

                                        /////
                                        // process mc
                                        /////
                                        var modIdx = 0;
                                        if (mc.length > 0) {
                                            for (var i = 0; i < this.moduleEnable.length; i++) {
                                                this.moduleEnable[i] = (i === 0) ? true : false
                                            }
    
                                            for (var a in mc) {
                                                if (mc[a].toLowerCase() === "x") {
                                                    for (var i = 2; i < this.moduleEnable.length; i++) {
                                                        if (i !== 3) {
                                                            this.moduleEnable[i] = false
                                                        }
                                                    }
                                                } else {
                                                    const i = parseInt(mc[a])
                                                    this.moduleEnable[i] = true
                                                }
                                            }

                                            for (var j = 0; j < 5; j++) {
                                                this.moduleCfg["0"][j] = 0
                                                this.moduleCfg["1"][j] = 0
                                            }

                                            for (var i = 0; i < mc.length && i < 10; i++) {
                                                const curMc = parseInt(mc[i]);
                                                console.log("mc["+i+"]:"+curMc);
                                                if (curMc != 3) {
                                                    if (modIdx < 4) {
                                                        this.moduleCfg["0"][modIdx] = curMc;
                                                    }
                                                    else
                                                    if (modIdx == 4) {
                                                        if (mc.length > 5) {
                                                            this.moduleCfg["0"][modIdx] = 3;
                                                            modIdx++;
                                                            this.moduleCfg["1"][modIdx-5] = curMc;    
                                                        } else {
                                                            this.moduleCfg["0"][modIdx] = curMc; 
                                                        }
                                                    }
                                                    else {
                                                        this.moduleCfg["1"][modIdx-5] = curMc;
                                                    }
                                                    modIdx++;
                                                } else {
                                                    if (modIdx < 4) {
                                                        this.moduleCfg["0"][modIdx] = curMc;
                                                        modIdx = 4;
                                                    } else {
                                                        this.moduleCfg["1"][modIdx-5] = curMc;
                                                    }
                                                    modIdx++;
                                                }
                                            }
                                        }

                                        //window.localStorage.setItem("accModule", JSON.stringify(this.accModule));
                                        window.localStorage.setItem("moduleCfg", JSON.stringify(this.moduleCfg));
                                        window.localStorage.setItem("moduleEnable", JSON.stringify(this.moduleEnable));

                                        setTimeout(function () { callback(true, null) }, 1000);
                                    })
                                    .catch((error: any) => {
                                        console.log("login err5");
                                        let msg = error.message;
                                        if (msg.indexOf("Unexpected token") >= 0) {
                                            msg = "Server Error";
                                        }
                                        callback(false, msg);
                                    });
                                }
                                else
                                    if (res.status == 404) {
                                        console.log("login err6");
                                        callback(false, "login err6");
                                    }
                                    else {
                                        console.log("status" + res.status);
                                        callback(false, "return status " + res.status);
                                    }
                            })
                            .catch((error: any) => {
                                console.log("login err7");
                                console.log(error);
                                callback(false, error);
                            });

                    } else {
                        console.log("login err4");
                        let msg = result.message;
                        if (msg.indexOf("Login failed") >= 0) {
                            msg = "Login failed";
                        }
                        else
                        if (msg.indexOf("Username not specified") >= 0) {
                            msg = "Username not specified";
                        }
                        callback(false, msg);
                    }
                })
                    .catch((error: any) => {
                        console.log("login err3");
                        console.log(error);
                        callback(false, error);
                        this.history.push("/page/settings/accounts/account/" + this.activeAcc);
                    });
            })
            .catch(e => {
                console.log("e:" + e);
                console.log("login err1");
                let msg = "Please check Account Settings or Internet Connection!";
                callback(false, msg);
            })
    }

    getRequest = (): RequestInit => {
        return {
            method: 'GET',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'omit',
            referrerPolicy: 'no-referrer',
            headers: {
                'Authorization': 'Basic ' + this.state.base64ticket
            }
        }
    }

    uploadRequest(formBody: any): RequestInit {
        var fheaders = {
            'Authorization': 'Basic ' + this.state.base64ticket
        }

        return {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'omit',
            referrerPolicy: 'no-referrer',
            headers: fheaders,
            body: formBody
        }
    }

    postRequest = (params: any, headers: any): RequestInit => {

        const formBody = Object.keys(params).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(params[key])).join('&');

        var fheaders = {
            'Authorization': 'Basic ' + this.state.base64ticket
            , ...headers
        }

        if (!fheaders['Content-Type']) {
            fheaders['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'
        }

        return {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'omit',
            referrerPolicy: 'no-referrer',
            headers: fheaders,
            body: formBody
        }
    }

    getKeyValue = (key: string) => (obj: Record<string, any>) => obj[key];

    parseParams = (params: any, id: any, inps: any) => {

        var finalParams = {
            "m": "MEMO",
            "formMode": (id ? "E" : "C"),
            "p1": "",
            "p2": "",
            "p3": "",
            "p4": ""
        };

        for (var pi = 0; pi < params.length; pi++) {

            var v = params[pi];

            var pos = v.indexOf("${");

            while (pos >= 0) {
                var pos2 = v.indexOf("}", pos + 2);
                if (pos2 >= 0) {
                    var fname = v.substring(pos + 2, pos2);

                    var fnameSearch = fname;
                    var prefix = fname.substring(0, 2);
                    if ((prefix !== "H_") && (prefix !== "F_")) {
                        fnameSearch = "F_" + fname;
                    }

                    //console.log("  fnameSearch:"+fnameSearch);
                    //        var f = parent.query("field[name="+fnameSearch.trim()+"]");
                    var f = this.getKeyValue(fnameSearch.trim())(inps);
                    var fv = "";
                    if (!f) {
                        console.log("Field Not Found : " + fnameSearch.trim());
                    }
                    else {
                        if (f instanceof Array) {
                            for (var i = 0; i < f.length; i++) {
                                var fi = f[i];
                                if (fi.inputType === "radio") {
                                    if (fi.checked) {
                                        fv = fi.inputValue;
                                        break;
                                    }
                                }
                                else {
                                    fv = fi.getValue();
                                }
                            }
                        } else {
                            //console.log("  f.value:"+f.value)
                            if (f.value) fv = f.value;
                        }
                    }
                    //console.log("  fv:"+fv);

                    v = v.replace("${" + fname + "}", fv);
                }
                else {
                    alert("Invalid Params : " + v);
                }

                pos = v.indexOf("${");
            }

            const pname = "p" + (pi + 1) as keyof typeof finalParams
            finalParams[pname] = v;
        }

        return finalParams;
    }

    finalSrcUrl = (srcUrl: string) => {

        srcUrl = this.util.getSrcUrl(srcUrl)
        if (!srcUrl.startsWith("main") && !srcUrl.startsWith("memo")) {
            srcUrl = "memo/" + srcUrl;
        }

        return srcUrl
    }

    listOptions = async (inp: any, id: any, inps: any, s: any = "", paramName: any = "s") => {
        console.log("listOption(" + inp.src_url + ":" + inp.src_param + ")")

        var srcUrl = inp.src_url;
        const srcParam = inp.src_param;

        srcUrl = this.finalSrcUrl(srcUrl)

        const ps = this.parseParams(srcParam.split(","), id, inps)

        var params: any = {
            "p1": ps.p1 + (paramName === "p1" && s ? " and " + s : "")
        }

        if (ps.p2) {
            params.p2 = ps.p2
        }

        if (ps.p3) {
            params.p3 = ps.p3
        }

        if (paramName === "s") {
            params.s = s
        }

        return await fetch(this.getFullUrl("srcUrl/" + srcUrl, params), this.getRequest())
            .then(res => {
                if (res.ok) {
                    return res.json()
                        .then((result) => {
                            if (result.success) {
                                return result.data;
                            }
                        })
                }
            });
    }

    isAllowModule(mid: any) {
        //return (mid!==0) && (this.accModule[mid] === 1)
        return (mid !== 0) && (this.moduleEnable[mid])
    }

    getHostPort() {
        return "https://" + this.state.host + ":" + this.state.port
    }

    getPrefixUrl() {
        return this.getHostPort() + Environment.BLEAF_PREFIX
    }

    getApiUrl() {
        return this.getHostPort() + Environment.API_PREFIX
    }

    getFullUrl(url: string, data: any) {
        return this.getPrefixUrl() + url + (url.indexOf("?") <= 0 ? "?" : "&") + new URLSearchParams(data)
    }

    getOldViewDocUrl = (docRef: string, name: string) => {
        // new
        //        var finalRef = docRef.substring(24);  // cut 'workspace://SpacesStore/'
        //        return this.getFullUrl("memo/doc/view", {"m":"1","doc":finalRef,"alf_ticket":this.state.ticket});

        // old
        var finalRef = docRef.replace("://", "/")
        var finalName = name.replace("#", "_").replace("%", "_")
        console.log("finalName:" + finalName)
        return this.getFullUrl("memo/viewDoc/" + finalName, { "m": "1", "doc": finalRef, "alf_ticket": this.state.ticket });
    }

    getViewDocUrl = (docRef: string, name: string) => {
        // new
        //        var finalRef = docRef.substring(24);  // cut 'workspace://SpacesStore/'
        //        return this.getFullUrl("memo/doc/view", {"m":"1","doc":finalRef,"alf_ticket":this.state.ticket});

        // old
        var finalRef = docRef.replace("://", "/")
        var finalName = name.replace("#", "_").replace("%", "_")
        console.log("finalName:" + finalName)
        //        return this.getFullUrl("memo/viewDoc/"+finalName, {"m":"1","doc":finalRef,"alf_ticket":this.state.ticket});
        return this.getFullUrl("memo/viewDoc", { "name": finalName, "m": "1", "doc": finalRef, "alf_ticket": this.state.ticket });
    }

    getScript = async (event: any, mid: any) => {
        console.log("getScript(" + event + "," + mid + ")")

        var params: any = {
            "event": event,
            "mId": mid
        }

        const url = "admin/mobile/format/script/get"

        return await fetch(this.getFullUrl(url, params), this.getRequest())
            .then(res => {
                if (res.ok) {
                    return res.json()
                        .then((result) => {
                            if (result.success) {
                                return result.data[0].script;
                            }
                        })
                }
            });
    }

    logout = () => {
        let state = this.state;

        state.username = "";
        state.password = "";
        state.ticket = "";
        state.base64ticket = "";
        state.pin = "";

        this.state = state;

        let astate = this.accounts[this.activeAcc];
        astate.username = "";
        astate.password = "";
        this.accounts[this.activeAcc] = astate;

        this.saveLocal();

    }

    render(): any {
        return (null);
    }
}

export default ServerService;
